import React, { Fragment } from "react"
import parse from "html-react-parser"
import { Link } from "gatsby"

import classNames from "classnames"

interface IBreadcrumbsProps {
  breadcrumbs: {
    label: string
    url: string
    /**
     * displays a span instead of a link when true
     */
    activeItem?: boolean
  }[]
  /**
   * class applied to the container div
   */
  className?: string
}

const Breadcrumbs = ({ breadcrumbs, className = "" }: IBreadcrumbsProps) => (
  <div className={classNames("my-5", className)}>
    <Link className="link" to="/">
      Home
    </Link>

    {breadcrumbs?.map?.(({ label, url, activeItem }, index) => {
      return (
        <Fragment key={index}>
          <span> / </span>
          {!activeItem && (
            <Link to={url} className="link">
              {label && parse(label)}
            </Link>
          )}
          {activeItem && <span>{label && parse(label)}</span>}
        </Fragment>
      )
    })}
  </div>
)

export default Breadcrumbs
